import { Base } from "../core/base.model";
import { Perfil } from "../security/perfil.model";
import { Persona } from "../security/persona.model";
import { Usuario } from "../security/usuario.model";
import { Puesto } from "./puesto.model";
import { Area } from "./area.model";
import { TareaDiaria } from "../tarea/tareaDiaria.model";


export class Empleado extends Base{
    idEmpleado: number;
	idUsuario: number;
	idPersona: number;
    idPuesto: number;
    token_personal: string;
    recibirCorreo:number;
    area_empleado: String;
    id_area: number;
    
	persona: Persona;
	usuario: Usuario;
    puesto: Puesto;
    area: Area;
    tarea: TareaDiaria;
    listaPerfiles: Perfil [];
  
}